// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3lJpF","unreadBadge":"styles_unreadBadge__3Po5f","modalContent":"styles_modalContent__2b0gf","modal":"styles_modal__1e2I9"};